export default __webpack_public_path__ + "static/media/bg_metalheads_hover.d2f36bbb.svg";